'use client';

import { c as _c } from "react/compiler-runtime";
import { Card } from '@achra/ui/card';
import { cn } from '@achra/ui/lib/utils';
import { getBudgetsByCodePath, getCodePathFromParams, getLevelOfDetail } from '@/modules/finances/lib/utils';
import { BUDGETS } from '../../mocks';
import { MOCK_BUDGETS_ANALYTICS } from '../../mocks/analytics';
import { BudgetUtilizationCard } from './budget-utilization-card';
import { DoughnutChart } from './doughnut-chart';
import { MobileChart } from './doughnut-chart/mobile-chart';
import { FilterTabs } from './filter-tabs';
import { useCardChartOverview } from './use-card-chart-overview';
interface SummarySectionProps {
  financeSlug?: string[];
}
function SummarySection(t0) {
  const $ = _c(26);
  const {
    financeSlug
  } = t0;
  let budgets;
  let codePath;
  let t1;
  if ($[0] !== financeSlug) {
    codePath = getCodePathFromParams(financeSlug);
    budgets = getBudgetsByCodePath(codePath, BUDGETS);
    t1 = getLevelOfDetail(codePath);
    $[0] = financeSlug;
    $[1] = budgets;
    $[2] = codePath;
    $[3] = t1;
  } else {
    budgets = $[1];
    codePath = $[2];
    t1 = $[3];
  }
  const levelNumber = t1;
  const cardOverViewSectionData = useCardChartOverview(budgets, MOCK_BUDGETS_ANALYTICS, levelNumber.levelOfDetail, BUDGETS, codePath);
  let t2;
  if ($[4] !== cardOverViewSectionData.budgetCap || $[5] !== cardOverViewSectionData.paymentsOnChain) {
    t2 = <div className="min-w-0 lg:w-[31.75%] lg:shrink-0"><BudgetUtilizationCard paymentsOnChain={cardOverViewSectionData.paymentsOnChain} budgetCap={cardOverViewSectionData.budgetCap} /></div>;
    $[4] = cardOverViewSectionData.budgetCap;
    $[5] = cardOverViewSectionData.paymentsOnChain;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("flex w-full flex-col gap-0 p-0", "bg-popover border-none md:flex-row");
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== cardOverViewSectionData.handleSelectedMetric || $[9] !== cardOverViewSectionData.selectedMetric) {
    t4 = <div data-slot="content" className="md:flex md:w-[29%]"><FilterTabs selectedMetric={cardOverViewSectionData.selectedMetric} onChangeTab={cardOverViewSectionData.handleSelectedMetric} /></div>;
    $[8] = cardOverViewSectionData.handleSelectedMetric;
    $[9] = cardOverViewSectionData.selectedMetric;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== cardOverViewSectionData.changeAlignment || $[12] !== cardOverViewSectionData.doughnutSeriesData || $[13] !== cardOverViewSectionData.numberSliderPerLevel || $[14] !== cardOverViewSectionData.selectedMetric || $[15] !== cardOverViewSectionData.showSwiper) {
    t5 = <div data-slot="chart-container" className="hidden pt-4 pr-6 pb-4 md:flex md:w-[71%]"><DoughnutChart seriesData={cardOverViewSectionData.doughnutSeriesData} selectedMetric={cardOverViewSectionData.selectedMetric} changeAlignment={cardOverViewSectionData.changeAlignment} showSwiper={cardOverViewSectionData.showSwiper} numberSliderPerLevel={cardOverViewSectionData.numberSliderPerLevel} /></div>;
    $[11] = cardOverViewSectionData.changeAlignment;
    $[12] = cardOverViewSectionData.doughnutSeriesData;
    $[13] = cardOverViewSectionData.numberSliderPerLevel;
    $[14] = cardOverViewSectionData.selectedMetric;
    $[15] = cardOverViewSectionData.showSwiper;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== cardOverViewSectionData.doughnutSeriesData) {
    t6 = <div data-slot="mobile-chart" className="md:hidden"><MobileChart seriesData={cardOverViewSectionData.doughnutSeriesData} /></div>;
    $[17] = cardOverViewSectionData.doughnutSeriesData;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t6) {
    t7 = <Card data-slot="card-container" className={t3}>{t4}{t5}{t6}</Card>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t2 || $[24] !== t7) {
    t8 = <div data-slot="main-content-section" className="flex min-w-0 flex-col gap-4 md:gap-6 lg:flex-row lg:gap-6 xl:gap-8">{t2}{t7}</div>;
    $[23] = t2;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}
export { SummarySection };